import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { NS } from '../../../i18n/constants/keys';
import { translateView } from '../../../i18n/helpers/translateView';
import { setCurrentView } from '../../../utils/redux_store/features/ViewReducer';
import { RootState } from '../../../utils/redux_store/store';
import { View } from '../../../utils/types/assessment_types';

const ViewOption: React.FC = () => {
  const { t } = useTranslation(NS.navbarMenus);
  const dispatch = useDispatch();
  const accessibleViews = useSelector(
    (state: RootState) => state.view.accessibleViews,
  );
  const currentView = useSelector((state: RootState) => state.view.currentView);
  const handleViewChange = (view: View) => {
    dispatch(setCurrentView(view));
  };

  return (
    <div className='grid grid-cols-2 gap-1 rounded-lg bg-slate-100 p-1 font-medium'>
      { accessibleViews.map((view: View) => (
        <button
            key={view}
            className={`rounded-md px-3 py-2 text-xs font-extrabold transition ${
              currentView === view
                ? 'bg-white text-emerald-700 shadow-sm'
                : 'text-slate-500 hover:text-slate-800'
            }`}
            onClick={() => handleViewChange(view)}
            disabled={!accessibleViews.includes(view)}
        >
          { translateView(t, view) }
        </button>
      )) }
    </div>
  );
};

export default ViewOption;
